module.exports = __webpack_public_path__ + "img/bg.15cc3757.png";